import React from "react";

function ButtonLoader() {
  return (
    <div className="absolute right-10 top-2 h-2 w-2">
      <div
        className="guest-web-loader h-2 w-2"
        style={{ width: "30px", height: "30px" }}
      ></div>
    </div>
  );
}

export default ButtonLoader;
